import {ThemeRadiusName, ThemeTypographyName} from '../../theme/types';
import {AvatarSize} from './types';

type AvatarLayoutMapType = {
  [size in AvatarSize]: {
    size: number;
    borderRadius: ThemeRadiusName;
    textVariant: ThemeTypographyName;
  };
};

export const AvatarLayoutMap: AvatarLayoutMapType = {
  '24': {
    size: 24,
    borderRadius: '4',
    textVariant: 'inline_12_default',
  },
  '30': {
    size: 30,
    borderRadius: '8',
    textVariant: 'inline_12_default',
  },
  '36': {
    size: 36,
    borderRadius: '8',
    textVariant: 'inline_16_default',
  },
  '96': {
    size: 96,
    borderRadius: '8',
    textVariant: 'inline_32_default',
  },
  '122': {
    size: 122,
    borderRadius: '8',
    textVariant: 'inline_56_default',
  },
};
